import { createFileRoute } from '@tanstack/react-router';
import { type AggregateBreadcrumb, buildBreadcrumb } from '@interxfi/app-components/components/router-breadcrumbs/router-breadcrumbs';

export const Route = createFileRoute(
  '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/customer-stock-record/_customer-stock-record',
)({
  loader: () =>
    ({
      breadcrumb: buildBreadcrumb({
        id: 'customer-stock-record',
        label: 'Core',
        to: '/clearing/operations/customer-stock-record',
      }),
    }) satisfies AggregateBreadcrumb,
});
